import { ResellerItem } from '../redux/types';

export const findResellerItem = (resellerItems: ResellerItem[], asin?: string): ResellerItem | undefined =>
    resellerItems.find((ri) => ri.asin === asin);
